import { render, staticRenderFns } from "./VQuillEditor.vue?vue&type=template&id=c49dec50&"
import script from "./VQuillEditor.vue?vue&type=script&lang=js&"
export * from "./VQuillEditor.vue?vue&type=script&lang=js&"
import style0 from "./VQuillEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports